var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldable',{attrs:{"label":_vm.label,"name":_vm.name,"errors":_vm.errors,"no":_vm.independent}},[_c('el-checkbox',{attrs:{"value":_vm.value},on:{"change":_vm.change},scopedSlots:_vm._u([(_vm.independent)?{key:"default",fn:function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]},proxy:true}:null],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }